import React from "react";
import { connect } from "react-redux";
import LegalPdfViewer from "./LegalPdfViewer";

const TC_PDF_MAP = {
  pt: "EVIO_Termos_e_Condicoes_20261012 PT.pdf",
  en: "EVIO_Termos_e_Condicoes_20261012 EN.pdf",
  es: "EVIO_Terminos_y_Condiciones_20261012_ES.pdf",
  fr: "EVIO_Conditions_Generales_20261012_FR.pdf",
  ca: "EVIO_Termos_e_Condicoes_20261012 ES-CA.pdf",
  eu: "EVIO_Termos_e_Condicoes_20261012 ES-EU.pdf",
  gl: "EVIO_Termos_e_Condicoes_20261012 ES-GL.pdf",
};

const getPdfFileName = (locale) => {
  const pathLocale = (window.location.pathname.split("/")[1] || "").toLowerCase();
  const current = (locale || pathLocale || "en").toLowerCase();

  if (TC_PDF_MAP[current]) {
    return TC_PDF_MAP[current];
  }
  const primary = current.split(/[-_]/)[0];
  return TC_PDF_MAP[primary] || TC_PDF_MAP["en"];
};

const TC = ({ locale }) => {
  const fileName = getPdfFileName(locale);
  const pdfUrl = `${process.env.PUBLIC_URL || ""}/assets/terms/${encodeURIComponent(fileName)}`;

  return (
    <LegalPdfViewer
      file={pdfUrl}
      loading="Loading terms and conditions..."
      error="The terms and conditions could not be loaded."
    />
  );
};

const mapStateToProps = (state) => ({
  locale: state.i18n ? state.i18n.locale : null,
});

export default connect(mapStateToProps)(TC);
